import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouter } from 'next/router';
import React, { useContext, useEffect } from 'react';
import { useMutation } from 'react-query';

import { QuestionPageContext } from '../QuestionPageProvider';

import theme from '$/assets/theme';
import HeadContentSection from '$/components/blocks/HeadContentSection';
import StudentQuestion from '$/components/blocks/StudentQuestion';
import Button from '$/components/elements/Button';
import Container from '$/components/elements/Container';
import Loader from '$/components/elements/Loader';
import { errorToast, successToast } from '$/components/elements/Toasts';
import { H6Typography, Sub2Typography } from '$/components/elements/Typography';
import useCurrentUser from '$/hooks/useCurrentUser';

const ConfirmEmail = () => {
  const { setCurrentStep, state } = useContext(QuestionPageContext);
  const router = useRouter();

  const previousStep = () => setCurrentStep('signUp', 0, { correctEmail: '1' });

  const { signIn } = useCurrentUser();

  useEffect(() => {
    history.pushState(null, '', router.asPath);
    window.addEventListener('popstate', () =>
      history.pushState(null, '', router.asPath)
    );
  }, []);

  const resendEmailMutation = useMutation(
    async () => await signIn(state.email),
    {
      onSuccess: () =>
        successToast({
          title: 'Erfolg!',
          description: 'Die Bestätigung wurde erneut an deine E-Mail gesendet',
        }),
      onError: (error: any) =>
        errorToast({
          title: 'Fehler!',
          description: error?.code || error,
        }),
    }
  );

  return (
    <StudentQuestion noLimitHeight>
      <HeadContentSection>
        <Container>
          <HeadContentSection.Wrapper>
            <div>
              <HeadContentSection.Title bold as="h1" color="grey7">
                Schau mal in dein
                <HeadContentSection.Underline>
                  E-Mail-Postfach
                </HeadContentSection.Underline>
              </HeadContentSection.Title>
              <Sub2Typography
                as="p"
                color="grey7"
                style={{ maxWidth: '400px', marginTop: '16px' }}
              >
                In unserer E-Mail findest du einen Link, um dich anzumelden und
                deine E-Mail-Adresse zu bestätigen.
              </Sub2Typography>
              <Sub2Typography bold>
                Dieser Link ist drei Minuten gültig.
              </Sub2Typography>
            </div>
            <HeadContentSection.StyledImage
              src="/images/girlLayingGreen.svg"
              alt="girl laying"
            />
          </HeadContentSection.Wrapper>
        </Container>
      </HeadContentSection>
      <StudentQuestion.Section>
        <Container>
          <StudentQuestion.Wrapper>
            <H6Typography bold as="h2" color="grey7">
              Keine E-Mail bekommen?
            </H6Typography>
            <Sub2Typography as="p" color="grey7" style={{ marginTop: '8px' }}>
              Vielleicht ist sie im Spam-Ordner gelandet. Oder hast du dich
              vertippt?
              <span style={{ color: theme.colors.functionalRed }}>
                {state.email}
              </span>
            </Sub2Typography>
            <div style={{ display: 'flex', alignItems: 'baseline' }}>
              <Button
                variant="text"
                title="Bestätigung noch einmal senden"
                disabled={resendEmailMutation.isLoading}
                textProps={{
                  style: { fontWeight: 'normal', fontSize: '15px' },
                }}
                buttonProps={{
                  onClick: resendEmailMutation.mutateAsync,
                  style: {
                    justifyContent: 'flex-start',
                    padding: '3px 0',
                    marginTop: '8px',
                  },
                }}
                leftIcon={<FontAwesomeIcon icon={faArrowRight} />}
              />
              {resendEmailMutation.isLoading && (
                <Loader style={{ marginLeft: '8px' }} />
              )}
            </div>
            <Button
              variant="text"
              title="E-Mail-Adresse korrigieren"
              textProps={{ style: { fontWeight: 'normal', fontSize: '15px' } }}
              buttonProps={{
                onClick: previousStep,
                style: {
                  justifyContent: 'flex-start',
                  padding: '3px 0',
                  marginTop: '8px',
                },
              }}
              leftIcon={<FontAwesomeIcon icon={faArrowRight} />}
            />
          </StudentQuestion.Wrapper>
        </Container>
      </StudentQuestion.Section>
    </StudentQuestion>
  );
};

export default ConfirmEmail;
